import hamburger from "./others/_hamburger.js";
import searchMenu from "./others/_search-menu.js";
import toggle from "./others/_toggle.js";
import cardsEstate from "./cards/_estate.js";
import othersSearchList from "./others/_search-list.js";
import othersSelectSearch from "./others/_select-search.js";
import buttonsFavorite from "./buttons/_favorite.js";
import buttonsShare from "./buttons/_share.js";
import formsSelect from "./forms/_select.js";
import footerSearch from "./others/_footer-search.js";
import otherHeadAlert from "./others/_head-alert.js";
import blockLifestyle from "./others/_block-lifestyle.js";
import formsInputCalendar from "./forms/_input-calendar.js";
import formsHScrollBar from "./forms/_h-scroll-bar.js";
import versionSelect from "./others/_version-select.js";
import zipAutofill from "./forms/_zip-autofill.js";
import estateCardList from "./forms/_estate-card-list.js";
import reserveSlots from "./forms/_reserve-slots.js";

const components = () => {
    hamburger();
    searchMenu();
    toggle();
    cardsEstate();
    othersSearchList();
    othersSelectSearch();
    buttonsFavorite();
    buttonsShare();
    formsSelect();
    footerSearch();
    otherHeadAlert();
    blockLifestyle();
    formsInputCalendar();
    formsHScrollBar();
    versionSelect();
    zipAutofill();
    estateCardList();
    reserveSlots();
};

export default components;
